<div class="p-grid">
  <div class="p-col-6">
    <div class="headerText">Customers</div>
  </div>
  <div class="p-col-6" style="text-align: right;">
    <div class="headerToggleDiv">
      @if(canSearchSecondaryContacts) {
      <label for="customerShowInactive">Include Secondary Contacts</label>
      <p-checkbox binary="true" inputId="includeSecondaryContacts" name="secondaryContacts" [(ngModel)]="includeSecondaryContacts" (ngModelChange)="setCustomers()">
      </p-checkbox>
      }

      <label for="customerShowInactive">Show Inactive Customers</label>
      <p-checkbox binary="true" inputId="customerShowInactive" name="showInactive" [(ngModel)]="getInactives" (ngModelChange)="setCustomers()">
      </p-checkbox>
    </div>
    <p-button type="button" severity="primary" (click)="addNew();" [disabled]="!canAdd">Add New</p-button>
  </div>
</div>

<p-table showGridlines stripedRows responsiveLayout="stack"
  #customerTable
  [columns]="cols"
  [value]="customers"
  [paginator]="true"
  [rows]="30"
  [lazy]="true"
  (onLazyLoad)="loadRequestLazy($event)"
  [totalRecords]="totalRecords"
  [loading]="loading"
>
<ng-template pTemplate="caption">
  <div style="display: flex; justify-content: space-between;">
    <span>
      <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
      <input
        name="customerSearch"
        type="text"
        pInputText
        size="50"
        placeholder="Search Customers..."
        [(ngModel)]="searchTerm"
        style="width:auto"
        (input)="customerTable.filterGlobal($event.target.value, 'contains')">
      </span>
      @if (canCombine) {
        <p-button name="combine" type="button" severity="info" (click)="showCombineCustomer = true" [disabled]="!canCombine">Combine Customers</p-button>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field">
          {{col.header}}
          @if (col.header != '') {
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-customer let-columns="columns" let-rowIndex="rowIndex">
    <tr>
      <td><span class="p-column-title">{{columns[0].header}}</span>{{customer.fullName}}</td>
      <td style="overflow-wrap: break-word;"><span class="p-column-title">{{columns[1].header}}</span>{{customer.customerType}}</td>
      <td><span class="p-column-title">{{columns[2].header}}</span>{{customer.phoneNumber | phoneNumber}}</td>
      <td><span class="p-column-title">{{columns[3].header}}</span>{{customer.address}}</td>
      <td><span class="p-column-title">{{columns[4].header}}</span>{{customer.state}}</td>
      <td><span class="p-column-title">{{columns[5].header}}</span>{{customer.zip}}</td>
      <td><span class="p-column-title">{{columns[6].header}}</span>{{customer.taxExempt ? 'Tax Exempt' : 'Taxable'}}</td>
      <td><span class="p-column-title">{{columns[7].header}}</span>{{customer.active == true ? 'Active' : 'Not Active'}}</td>
      <td>
        <p-button type="button" icon="pi pi-pencil" (click)="editCustomer(customer)"
          severity="info">
        </p-button>
        @if (showDeleteForCustomer(customer)) {
          <p-button [disabled]="!canEditAndDelete" type="p-button" icon="pi pi-trash"
            (click)="deleteCustomer(customer)" class="tableButtonMarginLeft" severity="danger"
            >
          </p-button>
        }
      </td>
    </tr>
  </ng-template>
</p-table>

@if (showCombineCustomer) {
  <div class="scrollableDialog">
    <p-dialog [(visible)]="showCombineCustomer" [modal]="true" [resizable]="true" [baseZIndex]="10000" [maximizable]="false" [style]="{'width': '1560px'}" [focusOnShow]="false" (onHide)="closedDialog()" [closable]="false" [blockScroll]="true" >
      <p-header>
        <span class="p-dialog-title">Combine Customers</span>
        <a style="float:right;" class="ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all" tabindex="0" role="button" (click)="closedDialog()" (keydown.enter)="closedDialog()" (mousedown)="closedDialog()">
          <span><i class="pi pi-times"></i></span>
        </a>
      </p-header>
      <app-combine-customer (closeEvent)="closedDialog()"></app-combine-customer>
    </p-dialog>
  </div>
}